module.exports = __webpack_public_path__ + "img/tu1.dce6bc2f.jpg";